import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const crm = axios.create({ baseURL: API, withCredentials: true });

crm.interceptors.request.use((config) => {
  const token = localStorage.getItem("mag_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const STATUS_META = {
  new: { label: "New", color: "#00BFFF" },
  contacted: { label: "Contacted", color: "#D4AF37" },
  consultation_booked: { label: "Consultation Booked", color: "#7C9CFF" },
  client: { label: "Client", color: "#4ADE80" },
  lost: { label: "Lost", color: "#8799B3" }
};

export const STATUS_ORDER = ["new", "contacted", "consultation_booked", "client", "lost"];

export function exportLeadsCsv(leads) {
  const headers = [
    "Name", "Email", "Phone", "Profession", "Employment", "Income Range",
    "Primary Concern", "Preferred Contact", "Heard About Us", "Status", "Assigned To", "Created", "Message"
  ];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const rows = leads.map((l) => [
    l.name, l.email, l.phone, l.profession, l.employment_structure, l.income_range,
    l.primary_concern, l.preferred_contact, l.lead_source || "", STATUS_META[l.status]?.label || l.status,
    l.assigned_to || "", new Date(l.created_at).toLocaleString(), l.message || ""
  ].map(esc).join(","));
  const csv = [headers.join(","), ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `matlock-leads-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
